export default class TimeRangeFilterType {
    static ALL_TIME = 'All Time';
    static TODAY = 'Today';
    static THIS_WEEK = 'This week';
    static THIS_MONTH = 'This month';
    static allCases = [this.ALL_TIME, this.TODAY, this.THIS_WEEK, this.THIS_MONTH];
}
